module.exports = __webpack_public_path__ + "img/Sweden.80217516.png";